import { KycUserInfo } from '@web/walter-lib/api'

export const checkRequiredKycData = (data: KycUserInfo) => {
    if (!data) {
        return false
    }

    const { address_1, city, country, email, first_name, last_name, zip } = data
    const requiredKycData = [address_1, city, country, email, first_name, last_name, zip]
    return !requiredKycData.some(dataItem => !dataItem)
}
